var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import T from '../../Utils/Locale';
import Select from '../../Components/ComponentSelect';
import PurchaseType, { getPurchaseTypesAsSelectOptions } from '../Purchase/PurchaseType';
import { updateItem } from '../Purchase/API';
import isProductDIY from '../../Utils/IsProductDIY';
import useEndpoint from '../../Hooks/UseEndpoint';
const SelectPurchaseType = ({ item, toggleLoading, updateBasket, classes = null, updateParentType = null }) => {
    const [selectedPurchaseType, setSelectedPurchaseType] = useState(item.purchase_type);
    const [options, setOptions] = useState(() => {
        // Always only allow to select full advice for non DIY products.
        if (!isProductDIY(item.product)) {
            return { [PurchaseType.ADVICE]: T(`purchase_type.${PurchaseType.ADVICE}`) };
        }
        return getPurchaseTypesAsSelectOptions(selectedPurchaseType === null, selectedPurchaseType);
    });
    useEffect(() => {
        if ((item === null || item === void 0 ? void 0 : item.purchase_type) != null && item.purchase_type !== selectedPurchaseType) {
            setSelectedPurchaseType(item.purchase_type);
        }
    }, [item]);
    useEndpoint(`/api/bookings?product=${item.product}&status=created,rebooked&is_paid=0`, (bookings) => __awaiter(void 0, void 0, void 0, function* () {
        let newOptions = Object.assign({}, options);
        // If any unpaid bookings exists, set the only purchase type as the booking type.
        if (bookings.length > 0) {
            bookings.shift().items.forEach(bookingItem => {
                if (bookingItem.document.type === item.product) {
                    newOptions = { [bookingItem.purchase_type]: options[bookingItem.purchase_type] };
                }
            });
        }
        setOptions(newOptions);
    }), `bookings_${item.product}`);
    const updateItemInBasket = (newPurchaseType) => __awaiter(void 0, void 0, void 0, function* () {
        if (newPurchaseType === selectedPurchaseType) {
            return;
        }
        setSelectedPurchaseType(newPurchaseType);
        if (typeof updateParentType === 'function')
            updateParentType(newPurchaseType);
        if (item.id) {
            toggleLoading(true);
            yield updateItem(item.id, newPurchaseType);
            yield updateBasket(false);
            toggleLoading(false);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx(Select, { onChange: (value) => updateItemInBasket(value), classes: `cursor-pointer tailwind-reset block appearance-none w-full bg-white font-normal text-gray-69 text-base py-1 pr-8 leading-tight focus:outline-none focus:shadow-outline ${classes}`, defaultValue: selectedPurchaseType, options: options, name: 'select-purchase-type' }), _jsx("span", Object.assign({ className: 'text-dark-teal pointer-events-none absolute inset-y-0 right-0 flex items-center px-2' }, { children: _jsx("svg", Object.assign({ className: 'fill-current w-3 h-3 -mt-1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 21 21', fill: 'none' }, { children: _jsx("path", { d: 'M4.338 9.229a1.892 1.892 0 00-2.676 2.675l2.676-2.675zm6.229 8.904l-1.338 1.338a1.892 1.892 0 002.676 0l-1.338-1.338zm8.904-6.229a1.892 1.892 0 10-2.675-2.675l2.675 2.675zm-17.809 0l7.567 7.567 2.676-2.675-7.567-7.567-2.676 2.675zm10.243 7.567l7.566-7.567-2.675-2.675-7.567 7.567 2.676 2.675z' }) })) }))] }));
};
SelectPurchaseType.propTypes = { updateParent: PropTypes.func };
export default SelectPurchaseType;
